<script lang="tsx">
import { ElBreadcrumb, ElBreadcrumbItem } from 'element-plus';
import { ref, watch, defineComponent, TransitionGroup } from 'vue';
import { useRouter } from 'vue-router';
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import { useDesign } from '@/hooks/web/useDesign';
import { MenuList, MenuMaps } from '@/router/modules';
const { getPrefixCls } = useDesign();

const prefixCls = getPrefixCls('breadcrumb');

export default defineComponent({
  name: 'Breadcrumb',
  setup() {
    // 面包屑图标
    const { currentRoute } = useRouter();

    const levelList = ref<any[]>([]);
    const getBreadcrumb = () => {
      const currentPath = currentRoute.value.matched.slice(-1)[0].path;
      const result = [...MenuList];
      const one = MenuList.find((el) => el.path === currentPath);
      if (one) {
        levelList.value = [one];
        return;
      }
      for (let i = 0; i < result.length; i++) {
        const item = result[i];
        if (item.childList) {
          const info = item.childList.find((el) => el.path === currentPath);
          if (info) {
            if (info.parentName) {
              const parent = MenuMaps.get(info.parentName);
              if (!parent) {
                console.error(`路由父节点设置有误${info.parentName}无法找到`, info);
              }
              levelList.value = [item, parent, info];
            } else {
              levelList.value = [item, info];
            }
            break;
          }
        }
      }
      // levelLjint
    };

    const renderBreadcrumb = () => {
      return levelList.value.map((v) => {
        return (
          <ElBreadcrumbItem to={{ path: v.path }} key={v.name}>
            {v.icon ? <i class={`iconfont pr-2 ${v.icon}`}></i> : ''}
            {v.title}
          </ElBreadcrumbItem>
        );
      });
    };

    watch(
      () => currentRoute.value,
      (route: RouteLocationNormalizedLoaded) => {
        if (route.path.startsWith('/redirect/')) {
          return;
        }
        getBreadcrumb();
      },
      {
        immediate: true,
      }
    );

    return () => (
      <ElBreadcrumb separator='/' class={`${prefixCls} flex items-center   ml-[10px]`}>
        <TransitionGroup appear enter-active-class='animate__animated animate__fadeInRight'>
          {renderBreadcrumb()}
        </TransitionGroup>
      </ElBreadcrumb>
    );
  },
});
</script>

<style lang="less" scoped>
@prefix-cls: ~'@{elNamespace}-breadcrumb';

.@{prefix-cls} {
  :deep(&__item) {
    display: flex;

    .@{prefix-cls}__inner {
      display: flex;
      align-items: center;
      color: var(--top-header-text-color);

      &:hover {
        color: var(--el-color-primary);
      }
    }
  }

  :deep(&__item):not(:last-child) {
    .@{prefix-cls}__inner {
      color: var(--top-header-text-color);

      &:hover {
        color: var(--el-color-primary);
      }
    }
  }

  :deep(&__item):last-child {
    .@{prefix-cls}__inner {
      color: var(--el-text-color-placeholder);

      &:hover {
        color: var(--el-text-color-placeholder);
      }
    }
  }
}
</style>
